import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PictureComponent from "components/core/picture/picture-component";
import { trackEvent } from "services/bigbrain-service";
import { GRID_TAG_CLICKED } from "constants/bigbrain-event-types";
import colors from "styles/colors";
import { ConditionalWrapper } from "utils/react";
import classnames from "classnames";
import DefaultProps from "./default-props";
import { StyledTag, StyledTagAnchorWrapper, TAG_IMAGE_SIZE } from "./tag.scss";
const Tag = (props)=>{
    const { tagIconsrc, tagText, onClick, tagBackgroundColor, tagImageHeight, href, openInNewTab, noImageWidth, tagTextSize } = props;
    const onTagClick = ()=>{
        trackEvent(GRID_TAG_CLICKED, {
            kind: tagText,
            info1: href
        });
        if (onClick) {
            onClick(tagText);
        }
    };
    const anchorWrapper = (children)=>{
        const target = openInNewTab ? "_blank" : undefined;
        return /*#__PURE__*/ _jsx(StyledTagAnchorWrapper, {
            className: "tag-anchor-wrapper",
            href: href,
            target: target,
            children: children
        });
    };
    const tagImageSize = tagImageHeight || TAG_IMAGE_SIZE;
    return /*#__PURE__*/ _jsx(ConditionalWrapper, {
        condition: href,
        wrapper: anchorWrapper,
        children: /*#__PURE__*/ _jsxs(StyledTag, {
            className: classnames("tag", {
                "has-on-click-behavior": onClick
            }),
            onClick: onTagClick,
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "tag-image-wrapper",
                    style: {
                        backgroundColor: colors[tagBackgroundColor],
                        height: tagImageSize,
                        width: !noImageWidth && tagImageSize
                    },
                    children: /*#__PURE__*/ _jsx(PictureComponent, {
                        className: "tag-icon",
                        pictureClass: "tag-picture",
                        src: tagIconsrc,
                        pictureComponentHeight: tagImageSize
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "tag-text",
                    style: {
                        fontSize: tagTextSize
                    },
                    children: tagText
                })
            ]
        })
    });
};
export default Tag;
Tag.defaultProps = DefaultProps;
